// extracted by mini-css-extract-plugin
module.exports = {"root":"Settings_root__3XZlA","grid":"Settings_grid__3IE0m"};